/** @jsxImportSource @emotion/react */
import { css, Global } from "@emotion/react";
import { Select } from "antd";
import config from "../../config";

const CustomSelect = ({ prefixIcon, multiSelect = false, children, ...rest }) => {
  const selectHeight = "30px";
  const textColor = config.color.textColor;
  const bgColor = '#2A3042';
  return (
    <div id="hello" className="custom-font" style={{position: "relative",minHeight: selectHeight}} css={css`
      .prefix-icon-wrapper {
        position: absolute;
        z-index: 1;
        width: 3rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: inherit !important;
      }

      .ant-select .ant-select-selector {
        background-color: ${bgColor} !important;
        border: 0 !important;
        color: ${textColor} !important;
        min-height: ${selectHeight} !important;
        font-family: inherit !important;
      }

      .ant-select-selection-search-input{
        font-size: 15px !important;
        font-weight: 500 !important;
        padding-left: calc(${prefixIcon && !multiSelect ? '3rem - 10px' : '0px'}) !important;
        padding-top: 1rem;
        min-height: ${selectHeight} !important;
        font-family: inherit !important;
      }

      .ant-select-selection-placeholder{
          color: gray !important;
          padding-left: calc(${prefixIcon ? '3rem - 10px' : '0px'}) !important;
          font-family: inherit !important;
      } 

      .ant-select-arrow{
        color: ${textColor};
        margin-top: -2px;
        font-family: inherit !important;
      }

      .ant-select-selection-item {
        padding-left: calc(${prefixIcon && !multiSelect ? '3rem - 10px' : '0px'}) !important;
        background-color: ${multiSelect ? "gray !important" : "transparent"};
        font-family: inherit !important;
      }
      .ant-select-selection-overflow{
        padding-left: calc(${prefixIcon ? '3rem - 10px' : '0px'}) !important;
        font-family: inherit !important;
      }
    `}>
      <Global
        styles={css`
          .ant-select-item-option-content {
            color: ${textColor} !important;
          }
          .ant-select-item-option-selected .ant-select-item-option-content{
            color: black !important;
          }
          .ant-select-selection-item {
            color: white !important;
          }

          .ant-empty-description{
            color: white !important;
          }
        `}
      />
      {prefixIcon && <div className="prefix-icon-wrapper">{prefixIcon}</div>}
      <Select 
        style={{fontFamily: "inherit"}}
        dropdownStyle={{backgroundColor: bgColor,borderColor: "#333333"}} 
        {...rest}
      >
        {children}
      </Select>
    </div>
  );
};

export default CustomSelect;